export const CurrencySymbol = Object.freeze({
  NGN: "₦",
  USD: "$",
});

export const DEFAULT_CURRENCY_SYMBOL = CurrencySymbol.NGN;
